/**
 * 維運公告
 * @function startMqMessageCheck 開始維運公告確認
 * @function terminationMqMessageCheck 終止維運公告確認
 * @event mqMessage 維運公告資訊
 */
// eslint-disable-next-line no-unused-vars
export class MqMessage extends EventTarget {
  // 維運公告 輪詢 API Interval
  _mqMessageAPIInterval = null
  // 社區 Id
  _comId = null
  // 維運公告 websocket
  _mqMessageWS = null
  // 維運公告內容
  mqMessage = []
  // 輪詢 API Url
  _apiUrl = ''
  // 輪詢 API Key
  _apiKey = ''
  // 維護公告 ws Url
  _wsUrl = ''

  syncNetworkInfo (apiUrl, apiKey, wsUrl) {
    if (!this._apiUrl || !this._apiKey || !this._wsUrl) {
      this._apiUrl = apiUrl
      this._apiKey = `ApiKey ${apiKey}`
      this._wsUrl = wsUrl
      return true
    }
    return false
  }

  /**
   * 開始 mqMessage API 輪詢。當輪詢時發現有維運公告，則停止輪詢，改接 websocket
   * @todo 最後要改回十分鐘，現在是十秒
   * @param comId 選填。若無帶入，則只取得系統維運公告；若有帶入，則還會取得社區、地區維運公告
   */
  startMqMessageCheck (comId) {
    this._comId = comId || null
    const params = {}
    if (this._comId) Object.assign(params, { ComId: this._comId })

    const providerMessageCheck = async () => {
      const res = await this._getProviderMessage()
      if (res) {
        this._handleProviderMessageResponse(res)
      }
    }

    const time = this._apiUrl.includes('-dev') ? 10 * 1000 : 10 * 60 * 1000

    // 10 分鐘輪詢檢查，dev 10 秒
    this._mqMessageAPIInterval = setInterval(() => {
      providerMessageCheck()
    }, time)

    providerMessageCheck()
  }

  /**
   * 呼叫輪詢 API
   */
  _getProviderMessage = async () => {
    try {
      let url = this._apiUrl
      if (this._comId) url += `?ComId=${this._comId}`
      const response = await fetch(url, {
        headers: {
          accept: '/',
          Authorization: this._apiKey
        },
        method: 'GET'
      })
      if (response.status === 200) return response.json()
      throw new Error(response)
    } catch (e) {
      // 不處理
      return null
    }
  }

  /**
   * 針對 mqMessage 輪詢 API response handle
   * 若有回傳資料，則設定維運公告訊息，並且終止輪詢，改為 websocket 連線
   * 系統維運公告優先級最高
   * @param res GetProviderMessage 的回傳
   */
  _handleProviderMessageResponse (res) {
    const { hasMessage, mqMessages } = res
    if (hasMessage && mqMessages.length > 0) {
      // 終止輪詢 API
      if (this._mqMessageAPIInterval) clearInterval(this._mqMessageAPIInterval)
      this._mqMessageAPIInterval = null
      this.mqMessage = mqMessages
      this.dispatchEvent(new CustomEvent('mqMessage', { detail: this.mqMessage }))

      this._connectMqMessageWS()
    } else if (!hasMessage) {
      this.mqMessage = []
      this.dispatchEvent(new CustomEvent('mqMessage', { detail: this.mqMessage }))
    }
  }

  /**
   * 訂閱 mqMessage websocket
   */
  _connectMqMessageWS () {
    this._mqMessageWS = new MqMessageWebSocket(this._wsUrl, this._comId)
    this._mqMessageWS.addEventListener('mqWSClose', this._handleMqMessageWSClose.bind(this))
    this._mqMessageWS.addEventListener('mqWSMessage', this._handleMqMessageWSMessage.bind(this))
  }

  /**
   * handle mqMessage websocket close 事件
   */
  _handleMqMessageWSClose () {
    if (this._mqMessageWS) this._mqMessageWS = null
  }


  /**
   * handle mqMessage websocket message 事件
   * @param event MqMessageWebSocket 的 message 事件，型別實際為 CustomEvent
   */
  _handleMqMessageWSMessage (event) {
    const { topic, title } = event.detail
    if (title) {
      const topicIndex = this.mqMessage.findIndex(item => item.topic === topic)
      if (topicIndex >= 0) this.mqMessage[topicIndex] = event.detail
      else this.mqMessage.push(event.detail)
    } else { // 沒 title 代表該 topic 為被關閉
      this.mqMessage = this.mqMessage.filter(item => item.topic !== topic)
    }
    this.dispatchEvent(new CustomEvent('mqMessage', { detail: this.mqMessage }))
  }

  /**
   * 終止 mqMessage 檢查。若是在 API 輪詢，則終止輪詢 Interval；若是在 websocket 連線中，則終止 websocket 連線
   */
  terminationMqMessageCheck () {
    if (this._mqMessageAPIInterval) {
      clearInterval(this._mqMessageAPIInterval)
      this._mqMessageAPIInterval = null
    }
    if (this._mqMessageWS) {
      this._mqMessageWS.close()
    }
    // 終止 socket
    this._comId = null
  }
}

/**
 * 維運公告 websocket
 * @param comId 選填。若無帶入，則只取得系統維運公告；若有帶入，則還會取得社區、地區維運公告
 * @function send websocket 發送訊息
 * @function close 終止 websocket 連線
 * @event mqWSMessage 維運公告資訊
 * @event mqWSClose 維運公告皆已關閉
 */
class MqMessageWebSocket extends EventTarget {
  // 維運公告 websocket url
  _mqMessageWSUrl = ''
  // 維運公告 websocket
  _mqMessageWS = null
  // 社區 Id
  _comId = null
  // heartbeat Interval
  _heartbeatInterval = null

  constructor (wsUrl, comId) {
    super()
    this._mqMessageWSUrl = wsUrl
    this._comId = comId || null
    this._mqMessageWS = new WebSocket(this._mqMessageWSUrl)

    this._mqMessageWS.onopen = this._onOpen.bind(this)
    this._mqMessageWS.onmessage = this._onMessage.bind(this)
    this._mqMessageWS.onclose = this._onClose.bind(this)
  }

  /**
   * websocket 連線完成 handle
   */
  _onOpen () {
    const subscribeMessage = {
      Type: 'subscribe',
      Data: {
        Client: 'HousekeeperWeb'
      }
    }
    if (this._comId) subscribeMessage.Data.ComId = this._comId
    const onOpenMessage = JSON.stringify(subscribeMessage)
    this.send(onOpenMessage)
    this._heartbeat()
  }

  /**
   * websocket 事件 handle
   * 將事件內容進行整理，若有資料，則發送事件回上層；若無資料，則中斷連線，並發送關閉事件回上層
   * @param event WebSocket 的 message 事件
   */
  _onMessage (event) {
    const { data } = event
    try {
      const parseData = JSON.parse(data)
      const { Topic: topic, Title: title, Message: message, EndAtUtc: endAtUtc, StartAtUtc: startAtUtc } = parseData
      this.dispatchEvent(new CustomEvent('mqWSMessage', { detail: { topic, title, message, endAtUtc, startAtUtc } }))
    } catch (e) {
      // 不處理
    }
  }

  /**
   * websocket 關閉事件 handle
   * 終止 heartbeat 並發送 close 事件
   */
  _onClose () {
    if (this._heartbeatInterval) {
      clearInterval(this._heartbeatInterval)
      this._heartbeatInterval = null
    }
    this.dispatchEvent(new Event('mqWSClose'))
  }

  /**
   * heartbeat 30 秒 ping 一次
   */
  _heartbeat () {
    const heartbeatEvent = () => {
      if (this._mqMessageWS?.readyState === WebSocket.OPEN) {
        const heartbeatMessage = JSON.stringify({
          Type: 'ping'
        })
        this.send(heartbeatMessage)
      }
    }

    this._heartbeatInterval = setInterval(heartbeatEvent, 30 * 1000)

    heartbeatEvent()
  }

  /**
   * websocket 送出資料
   * @param message 要發送至 websocket 的訊息內容
   */
  send (message) {
    if (!this._mqMessageWS) return
    this._mqMessageWS.send(message)
  }

  /**
   * websocket 中斷連線，並終止 heartbeat
   */
  close () {
    if (this._mqMessageWS) this._mqMessageWS.close()
  }
}
